import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import { ArrowBigUpDash } from 'lucide-react';
// import qs from 'qs';
// Actions
// import { useSubscriptionFlow } from '@src/hooks/use-subscription-flow';
// import { setOpenUpgrade } from '@src/store/slices/billing';
// import { HANDLE_PLANS_DIALOG } from 'actions/user';
import { ResponsiveDialog, UpgradeLockModal } from 'ui/components';
import { useLockFeature } from '../../../hooks/use-lock-feature';
import { getShowLockFeature, getUser, setShowLockFeature } from '../../../store/userSlice';


interface LockFeatureModalProps {
    lockTitle?: string;
    lockParagraph?: string;
    lockImg?: string;

    closeOnAction?: boolean;
}


const LockFeatureModal: FC<LockFeatureModalProps> = () => {

    const user = useSelector(getUser)
    const showLockFeature = useSelector(getShowLockFeature);

    const dispatch = useDispatch();


    const {
        activePlan,
        calculateBasePrice,
        calculateBaseTeamSeatCost,
        returnPlanPeriodValue,
        handleSubscribe,
        handleComparePlans
    } = useLockFeature({ rank: user.rank });

    const handleClose = (bool: boolean) => {
        dispatch(setShowLockFeature({
            showLockFeature: bool,
            lockImg: '',
            lockParagraph: '',
            lockTitle: '',
            rank: 2,
        }));
    };


    return (
        <>
            <ResponsiveDialog
                open={showLockFeature && !!activePlan}
                onOpenChange={handleClose}
            >
                {showLockFeature && activePlan && (
                    <UpgradeLockModal
                        planName={activePlan.display_name}
                        featureTitle={user.lockTitle || ''}
                        featureDescription={user.lockParagraph || ''}
                        // basePrice={calculateBasePrice(activePlan)}
                        basePrice={calculateBasePrice(activePlan).toString()}
                        additionalSeatPrice={`$${calculateBaseTeamSeatCost()}`}
                        onSubscribe={() => handleSubscribe({ user: user.raw?.plan.users })}
                        className="isolate"
                        imageSrc={user.lockImg || ''}
                        currentInterval={returnPlanPeriodValue('mon.', 'year', '2years')}
                        // startingCheckout={startingCheckout}
                        openComparePlans={handleComparePlans}
                        // openComparePlans={() => dispatch(setOpenUpgrade(true))}
                        rank={activePlan.rank}
                        container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
                    />
                )}
            </ResponsiveDialog>
        </>
    );
};

export default LockFeatureModal;